
import "C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/settings/styles/loading.less?modules";
export default {"animate": `animate-GK4I2JdS`,"shadow": `shadow-pychpvJ4`,"loading": `loading-Y1Tcm3lm`}
